type CompanyDomain = "sm" | "calmap" | "santamaria";
type Company = {
  id: number;
  name: string;
  website?: string;
}

const DEV = window.location.hostname.includes("dev") || window.location.hostname.includes("localhost");

const COMPANY_ALIAS_BY_ID: Record<number, CompanyDomain> = {
  // Ajuste conforme os IDs reais das empresas no banco.
  // Exemplo: 1: "sm"
  1: "sm",
  2: "calmap",
  26: "santamaria"
};
const COMPANY_ALIAS_BY_NORMALIZED_NAME: Record<string, CompanyDomain> = {
  "sm minerios": "sm",
  calmap: "calmap",
  "santa maria": "santamaria"
};

const normalizeCompanyName = (value: string) =>
  value
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim()
    .replace(/\s+/g, " ");

const getWebsiteHost = (website?: string) => {
  if (!website) {
    return null;
  }

  const trimmedWebsite = website.trim();

  if (!trimmedWebsite) {
    return null;
  }

  const parsedWebsite = /^https?:\/\//i.test(trimmedWebsite)
    ? trimmedWebsite
    : `https://${trimmedWebsite}`;

  try {
    return new URL(parsedWebsite).hostname;
  } catch {
    // Fallback for malformed values while keeping only host-like content.
    const sanitizedWebsite = trimmedWebsite
      .replace(/^https?:\/\//i, "")
      .split("/")[0]
      .trim();

    return sanitizedWebsite || null;
  }
};

export const buildCompanyLoginHost = (company: Company) => {
  const websiteHost = getWebsiteHost(company.website);

  if (websiteHost) {
    return DEV && !websiteHost.startsWith("dev") ? `dev${websiteHost}` : websiteHost;
  }

  const normalizedName = normalizeCompanyName(company.name);
  const aliasById = COMPANY_ALIAS_BY_ID[company.id];
  const aliasByName = COMPANY_ALIAS_BY_NORMALIZED_NAME[normalizedName];
  const alias = aliasById ?? aliasByName ?? normalizedName.replace(/\s+/g, "");
  const baseDomain = "nextcargo.app";

  return DEV ? `dev${alias}.${baseDomain}` : `${alias}.${baseDomain}`;
};

export const buildCompanyLoginUrl = (company: Company, path = "/app/login") => {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;

  return `${window.location.protocol}//${buildCompanyLoginHost(company)}${normalizedPath}`;
};
